module.exports = __webpack_public_path__ + "img/Group-30-1-1.097d9683.webp";